import { render, staticRenderFns } from "./classe.vue?vue&type=template&id=1f4fa5d8&"
import script from "./classe.vue?vue&type=script&lang=js&"
export * from "./classe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports